// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 800px;
    max-height: 80vh;
    overflow-y: auto;
    position: relative;
}

.job-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
}

.job-info-container {
    display: flex;
    gap: 40px;
    margin-top: 20px;
    flex-wrap: wrap;
}

.job-description,
.job-details {
    flex: 1 1;
}

.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
}

.info-label {
    font-weight: bold;
    color: #333;
}

.info-value {
    color: #666;
}

.action-buttons {
    text-align: center;
    margin-top: 20px;
}

.apply-button {
    padding: 10px 24px;
    background-color: #2196F3;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 8px;
    background-color: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styleSheet/ViewJob.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,eAAe;AACnB","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    width: 80%;\n    max-width: 800px;\n    max-height: 80vh;\n    overflow-y: auto;\n    position: relative;\n}\n\n.job-title {\n    text-align: center;\n    font-size: 24px;\n    font-weight: bold;\n}\n\n.job-info-container {\n    display: flex;\n    gap: 40px;\n    margin-top: 20px;\n    flex-wrap: wrap;\n}\n\n.job-description,\n.job-details {\n    flex: 1;\n}\n\n.info-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.info-label {\n    font-weight: bold;\n    color: #333;\n}\n\n.info-value {\n    color: #666;\n}\n\n.action-buttons {\n    text-align: center;\n    margin-top: 20px;\n}\n\n.apply-button {\n    padding: 10px 24px;\n    background-color: #2196F3;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    padding: 8px;\n    background-color: transparent;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
